import styled from '@emotion/styled';

export const PageHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
